export default "__VITE_ASSET__Ov73uC_t__"